import { ReactNode, useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'

interface AssistantLayoutProps {
  children: ReactNode
}

/**
 * Full-height layout for the AI Assistant (Research Lab) page.
 * Unlike MainLayout it removes the inner padding and lets the three-pane
 * workspace fill the full available viewport height.
 */
export default function AssistantLayout({ children }: AssistantLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gray-50">
      {/* App Sidebar (navigation) */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content area — offset for sidebar on desktop */}
      <div className="lg:pl-64 flex flex-col flex-1 min-h-0">
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Workspace — fills remaining height, no padding */}
        <div className="flex-1 min-h-0 overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  )
}

